module.exports = __webpack_public_path__ + "static/media/humanFigureFemale.13c98bd8.png";